// footer component
const Footer = () => {
  return (
    <>
      <footer className="flex justify-center md:justify-end px-4 py-4 lg:py-2 mx-auto max-w-7xl lg:fixed lg:bottom-0 lg:right-0">
        <a
          href="https://shubhambhoj.in"
          className="mb-8 text-sm font-bold text-center text-gray-700 md:text-left md:mb-0"
          rel="noopener noreferrer"
        >
          © Copyright 2022 Shubham Singh.
        </a>
      </footer>
    </>
  );
};

export default Footer;
